export default __webpack_public_path__ + "static/service3-45c87e6faf32005084ce7e170a5a3aaf.png";